(function ($) {
    /* Slide out menu
    ====================================================================*/

    //include slideout menu custom
    !(function (t) {
        if ("object" == typeof exports && "undefined" != typeof module)
            module.exports = t();
        else if ("function" == typeof define && define.amd) define([], t);
        else {
            var e;
            "undefined" != typeof window
                ? (e = window)
                : "undefined" != typeof global
                ? (e = global)
                : "undefined" != typeof self && (e = self),
                (e.Slideout = t());
        }
    })(function () {
        var t, e, n;
        return (function i(t, e, n) {
            function o(r, a) {
                if (!e[r]) {
                    if (!t[r]) {
                        var u = typeof require == "function" && require;
                        if (!a && u) return u(r, !0);
                        if (s) return s(r, !0);
                        var l = new Error("Cannot find module '" + r + "'");
                        throw ((l.code = "MODULE_NOT_FOUND"), l);
                    }
                    var f = (e[r] = { exports: {} });
                    t[r][0].call(
                        f.exports,
                        function (e) {
                            var n = t[r][1][e];
                            return o(n ? n : e);
                        },
                        f,
                        f.exports,
                        i,
                        t,
                        e,
                        n
                    );
                }
                return e[r].exports;
            }
            var s = typeof require == "function" && require;
            for (var r = 0; r < n.length; r++) o(n[r]);
            return o;
        })(
            {
                1: [
                    function (t, e, n) {
                        "use strict";
                        var i = t("decouple");
                        var o = t("emitter");
                        var s;
                        var r = false;
                        var a = window.document;
                        var u = a.documentElement;
                        var l = window.navigator.msPointerEnabled;
                        var f = {
                            start: l ? "MSPointerDown" : "touchstart",
                            move: l ? "MSPointerMove" : "touchmove",
                            end: l ? "MSPointerUp" : "touchend",
                        };
                        var h = (function v() {
                            var t = /^(Webkit|Khtml|Moz|ms|O)(?=[A-Z])/;
                            var e = a.getElementsByTagName("script")[0].style;
                            for (var n in e) {
                                if (t.test(n)) {
                                    return (
                                        "-" + n.match(t)[0].toLowerCase() + "-"
                                    );
                                }
                            }
                            if ("WebkitOpacity" in e) {
                                return "-webkit-";
                            }
                            if ("KhtmlOpacity" in e) {
                                return "-khtml-";
                            }
                            return "";
                        })();
                        function c(t, e) {
                            for (var n in e) {
                                if (e[n]) {
                                    t[n] = e[n];
                                }
                            }
                            return t;
                        }
                        function p(t, e) {
                            t.prototype = c(t.prototype || {}, e.prototype);
                        }
                        function d(t) {
                            while (t.parentNode) {
                                if (
                                    t.getAttribute("data-slideout-ignore") !==
                                    null
                                ) {
                                    return t;
                                }
                                t = t.parentNode;
                            }
                            return null;
                        }
                        function _(t) {
                            t = t || {};
                            this._startOffsetX = 0;
                            this._currentOffsetX = 0;
                            this._opening = false;
                            this._moved = false;
                            this._opened = false;
                            this._preventOpen = false;
                            this._touch =
                                t.touch === undefined ? true : t.touch && true;
                            this._side = t.side || "left";
                            this.panel = t.panel;
                            this.menu = t.menu;
                            if (
                                !this.panel.classList.contains("slideout-panel")
                            ) {
                                this.panel.classList.add("slideout-panel");
                            }
                            if (
                                !this.panel.classList.contains(
                                    "slideout-panel-" + this._side
                                )
                            ) {
                                this.panel.classList.add(
                                    "slideout-panel-" + this._side
                                );
                            }
                            if (
                                !this.menu.classList.contains("slideout-menu")
                            ) {
                                this.menu.classList.add("slideout-menu");
                            }
                            if (
                                !this.menu.classList.contains(
                                    "slideout-menu-" + this._side
                                )
                            ) {
                                this.menu.classList.add(
                                    "slideout-menu-" + this._side
                                );
                            }
                            this._fx = t.fx || "ease";
                            this._duration = parseInt(t.duration, 10) || 300;
                            this._tolerance = parseInt(t.tolerance, 10) || 70;
                            this._padding = this._translateTo =
                                parseInt(t.padding, 10) || 256;
                            this._orientation = this._side === "right" ? -1 : 1;
                            this._translateTo *= this._orientation;
                            if (this._touch) {
                                this._initTouchEvents();
                            }
                        }
                        p(_, o);
                        _.prototype.open = function () {
                            var t = this;
                            this.emit("beforeopen");
                            if (!u.classList.contains("slideout-open")) {
                                u.classList.add("slideout-open");
                            }
                            this._setTransition();
                            this._translateXTo(this._translateTo);
                            this._opened = true;
                            setTimeout(function () {
                                t.panel.style.transition = t.panel.style[
                                    "-webkit-transition"
                                ] = "";
                                t.emit("open");
                            }, this._duration + 50);
                            return this;
                        };
                        _.prototype.close = function () {
                            var t = this;
                            if (!this.isOpen() && !this._opening) {
                                return this;
                            }
                            this.emit("beforeclose");
                            this._setTransition();
                            this._translateXTo(0);
                            this._opened = false;
                            setTimeout(function () {
                                u.classList.remove("slideout-open");
                                t.panel.style.transition =
                                    t.panel.style["-webkit-transition"] =
                                    t.panel.style[h + "transform"] =
                                    t.panel.style.transform =
                                        "";
                                t.emit("close");
                            }, this._duration + 50);
                            return this;
                        };
                        _.prototype.toggle = function () {
                            return this.isOpen() ? this.close() : this.open();
                        };
                        _.prototype.isOpen = function () {
                            return this._opened;
                        };
                        _.prototype._translateXTo = function (t) {
                            this._currentOffsetX = t;
                            this.panel.style[h + "transform"] =
                                this.panel.style.transform =
                                    "translateX(" + t + "px)";
                            return this;
                        };
                        _.prototype._setTransition = function () {
                            this.panel.style[h + "transition"] =
                                this.panel.style.transition =
                                    h +
                                    "transform " +
                                    this._duration +
                                    "ms " +
                                    this._fx;
                            return this;
                        };
                        _.prototype._initTouchEvents = function () {
                            var t = this;
                            this._onScrollFn = i(a, "scroll", function () {
                                if (!t._moved) {
                                    clearTimeout(s);
                                    r = true;
                                    s = setTimeout(function () {
                                        r = false;
                                    }, 250);
                                }
                            });
                            this._preventMove = function (e) {
                                if (t._moved) {
                                    e.preventDefault();
                                }
                            };
                            a.addEventListener(f.move, this._preventMove);
                            this._resetTouchFn = function (e) {
                                if (typeof e.touches === "undefined") {
                                    return;
                                }
                                t._moved = false;
                                t._opening = false;
                                t._startOffsetX = e.touches[0].pageX;
                                t._preventOpen =
                                    !t._touch ||
                                    (!t.isOpen() && t.menu.clientWidth !== 0);
                            };
                            this.panel.addEventListener(
                                f.start,
                                this._resetTouchFn
                            );
                            this._onTouchCancelFn = function () {
                                t._moved = false;
                                t._opening = false;
                            };
                            this.panel.addEventListener(
                                "touchcancel",
                                this._onTouchCancelFn
                            );
                            this._onTouchEndFn = function () {
                                if (t._moved) {
                                    t.emit("translateend");
                                    t._opening &&
                                    Math.abs(t._currentOffsetX) > t._tolerance
                                        ? t.open()
                                        : t.close();
                                }
                                t._moved = false;
                            };
                            this.panel.addEventListener(
                                f.end,
                                this._onTouchEndFn
                            );
                            this._onTouchMoveFn = function (e) {
                                if (
                                    r ||
                                    t._preventOpen ||
                                    typeof e.touches === "undefined" ||
                                    d(e.target)
                                ) {
                                    return;
                                }
                                var n = e.touches[0].clientX - t._startOffsetX;
                                var i = (t._currentOffsetX = n);
                                if (Math.abs(i) > t._padding) {
                                    return;
                                }
                                if (Math.abs(n) > 20) {
                                    t._opening = true;
                                    var o = n * t._orientation;
                                    if (
                                        (t._opened && o > 0) ||
                                        (!t._opened && o < 0)
                                    ) {
                                        return;
                                    }
                                    if (!t._moved) {
                                        t.emit("translatestart");
                                    }
                                    if (o <= 0) {
                                        i = n + t._padding * t._orientation;
                                        t._opening = false;
                                    }
                                    if (
                                        !(
                                            t._moved &&
                                            u.classList.contains(
                                                "slideout-open"
                                            )
                                        )
                                    ) {
                                        u.classList.add("slideout-open");
                                    }
                                    t.panel.style[h + "transform"] =
                                        t.panel.style.transform =
                                            "translateX(" + i + "px)";
                                    t.emit("translate", i);
                                    t._moved = true;
                                }
                            };
                            this.panel.addEventListener(
                                f.move,
                                this._onTouchMoveFn
                            );
                            return this;
                        };
                        _.prototype.enableTouch = function () {
                            this._touch = true;
                            return this;
                        };
                        _.prototype.disableTouch = function () {
                            this._touch = false;
                            return this;
                        };
                        _.prototype.destroy = function () {
                            this.close();
                            a.removeEventListener(f.move, this._preventMove);
                            this.panel.removeEventListener(
                                f.start,
                                this._resetTouchFn
                            );
                            this.panel.removeEventListener(
                                "touchcancel",
                                this._onTouchCancelFn
                            );
                            this.panel.removeEventListener(
                                f.end,
                                this._onTouchEndFn
                            );
                            this.panel.removeEventListener(
                                f.move,
                                this._onTouchMoveFn
                            );
                            a.removeEventListener("scroll", this._onScrollFn);
                            this.open = this.close = function () {};
                            return this;
                        };
                        e.exports = _;
                    },
                    { decouple: 2, emitter: 3 },
                ],
                2: [
                    function (t, e, n) {
                        "use strict";
                        var i = (function () {
                            return (
                                window.requestAnimationFrame ||
                                window.webkitRequestAnimationFrame ||
                                function (t) {
                                    window.setTimeout(t, 1e3 / 60);
                                }
                            );
                        })();
                        function o(t, e, n) {
                            var o,
                                s = false;
                            function r(t) {
                                o = t;
                                a();
                            }
                            function a() {
                                if (!s) {
                                    i(u);
                                    s = true;
                                }
                            }
                            function u() {
                                n.call(t, o);
                                s = false;
                            }
                            t.addEventListener(e, r, false);
                            return r;
                        }
                        e.exports = o;
                    },
                    {},
                ],
                3: [
                    function (t, e, n) {
                        "use strict";
                        var i = function (t, e) {
                            if (!(t instanceof e)) {
                                throw new TypeError(
                                    "Cannot call a class as a function"
                                );
                            }
                        };
                        n.__esModule = true;
                        var o = (function () {
                            function t() {
                                i(this, t);
                            }
                            t.prototype.on = function e(t, n) {
                                this._eventCollection =
                                    this._eventCollection || {};
                                this._eventCollection[t] =
                                    this._eventCollection[t] || [];
                                this._eventCollection[t].push(n);
                                return this;
                            };
                            t.prototype.once = function n(t, e) {
                                var n = this;
                                function i() {
                                    n.off(t, i);
                                    e.apply(this, arguments);
                                }
                                i.listener = e;
                                this.on(t, i);
                                return this;
                            };
                            t.prototype.off = function o(t, e) {
                                var n = undefined;
                                if (
                                    !this._eventCollection ||
                                    !(n = this._eventCollection[t])
                                ) {
                                    return this;
                                }
                                n.forEach(function (t, i) {
                                    if (t === e || t.listener === e) {
                                        n.splice(i, 1);
                                    }
                                });
                                if (n.length === 0) {
                                    delete this._eventCollection[t];
                                }
                                return this;
                            };
                            t.prototype.emit = function s(t) {
                                var e = this;
                                for (
                                    var n = arguments.length,
                                        i = Array(n > 1 ? n - 1 : 0),
                                        o = 1;
                                    o < n;
                                    o++
                                ) {
                                    i[o - 1] = arguments[o];
                                }
                                var s = undefined;
                                if (
                                    !this._eventCollection ||
                                    !(s = this._eventCollection[t])
                                ) {
                                    return this;
                                }
                                s = s.slice(0);
                                s.forEach(function (t) {
                                    return t.apply(e, i);
                                });
                                return this;
                            };
                            return t;
                        })();
                        n["default"] = o;
                        e.exports = n["default"];
                    },
                    {},
                ],
            },
            {},
            [1]
        )(1);
    });

    /*
    var slideout = new Slideout({
        'panel': document.getElementById('panel'),
        'menu': document.getElementById('menu'),
        'padding': 400,
        'side': 'right',
        'tolerance': 70
    });

    // Toggle button
    document.querySelector('.js-slideout-toggle').addEventListener('click', function() {
        slideout.toggle();
    });

    // //toggle button 2
    document.querySelector('.slideout-menu .close-button').addEventListener('click', function() {
        slideout.toggle();
    });*/

    $(".js-slideout-toggle").click(function () {
        $("#panel").toggleClass("panel-active");
    });

    $("#side-close").click(function () {
        $("#panel").toggleClass("panel-active");
    });

    $(".btn-poptat").click(function () {
        $("#panel").toggleClass("panel-active");
    });

    $(".js-slideout-toggle").click(function () {
        $("#menu").toggleClass("slideout-menu-active");
    });

    $("#side-close").click(function () {
        $("#menu").toggleClass("slideout-menu-active");
    });

    $(".btn-poptat").click(function () {
        $("#menu").toggleClass("slideout-menu-active");
    });

    /* slidein functionality
    ========================================================*/

    $(".slideItem:nth-of-type(1)").addClass("slide-left");
    $(".slideItem:nth-of-type(2)").addClass("slide-up");
    $(".slideItem:nth-of-type(3)").addClass("slide-right");
    $(".slideItem:nth-of-type(4)").addClass("slide-left");
    $(".slideItem:nth-of-type(5)").addClass("slide-up");
    $(".slideItem:nth-of-type(6)").addClass("slide-right");
    $(".slideItem:nth-of-type(7)").addClass("slide-left");
    $(".slideItem:nth-of-type(8)").addClass("slide-up");
    $(".slideItem:nth-of-type(9)").addClass("slide-right");

    /**
     * Copyright 2012, Digital Fusion
     * Licensed under the MIT license.
     * http://teamdf.com/jquery-plugins/license/
     *
     * @author Sam Sehnert
     * @desc A small plugin that checks whether elements are within
     *     the user visible viewport of a web browser.
     *     only accounts for vertical position, not horizontal.
     */

    $.fn.visible = function (partial, offset) {
        var $t = $(this),
            $w = $(window),
            viewTop = $w.scrollTop(),
            viewBottom = viewTop + $w.height(),
            _top = $t.offset().top - offset,
            _bottom = _top + $t.height() + offset,
            compareTop = partial === true ? _bottom : _top,
            compareBottom = partial === true ? _top : _bottom;

        return compareBottom <= viewBottom && compareTop >= viewTop;
    };

    var win = $(window);
    var allMods = $(".slide-up");
    var allLeft = $(".slide-left");
    var allRight = $(".slide-right");
    var allFade = $(".fade-in");
    var allMods2 = $(".slide-up-offset");
    var allGuy = $(".slide-up-guy");

    // Detect width for offet
    function detectWidth() {
        var windowWidth;
        if (window.screen.width >= 1024) {
            var windowWidth = 500;
        }
        if (window.screen.width <= 1023) {
            var windowWidth = 250;
        }

        if (window.screen.width >= 640) {
            var windowWidth = 0;
        }

        return windowWidth;
    }

    win.on("scroll load", function (event) {
        allGuy.each(function (i, el) {
            var el = $(el);
            if (el.visible(true, 500)) {
                el.addClass("come-in");
            }
        });

        //slide up
        allMods.each(function (i, el) {
            var el = $(el);
            if (el.visible(true, 200)) {
                el.addClass("come-in");
            }
        });

        //slide up
        allMods2.each(function (i, el) {
            var el = $(el);
            if (el.visible(true, detectWidth())) {
                el.addClass("come-in");
            }
        });

        allLeft.each(function (i, el) {
            var el = $(el);
            if (el.visible(true, 0)) {
                el.addClass("come-in");
            }
        });

        allRight.each(function (i, el) {
            var el = $(el);
            if (el.visible(true, 0)) {
                el.addClass("come-in");
            }
        });

        allFade.each(function (i, el) {
            var el = $(el);
            if (el.visible(true, 0)) {
                el.addClass("come-in");
            }
        });
    });

    /**

     * jquery-doubleTapToGo plugin

     * Copyright 2017 DACHCOM.DIGITAL AG

     * @author Marco Rieser

     * @author Volker Andres

     * @author Stefan Hagspiel

     * @version 3.0.2

     * @see https://github.com/dachcom-digital/jquery-doubletaptogo

     */

    (function ($, window, document, undefined) {
        "use strict";

        var pluginName = "doubleTapToGo",
            defaults = {
                automatic: true,
                selectorClass: "doubletap",
                selectorChain: "li:has(ul)",
            };

        function DoubleTapToGo(element, options) {
            this.element = element;
            this.settings = $.extend({}, defaults, options);
            this._defaults = defaults;
            this._name = pluginName;
            this.init();
        }

        $.extend(DoubleTapToGo.prototype, {
            preventClick: false,

            currentTap: $(),

            init: function () {
                $(this.element)
                    .on(
                        "touchstart",
                        "." + this.settings.selectorClass,
                        this._tap.bind(this)
                    )

                    .on(
                        "click",
                        "." + this.settings.selectorClass,
                        this._click.bind(this)
                    )

                    .on("remove", this._destroy.bind(this));

                this._addSelectors();
            },

            _addSelectors: function () {
                if (this.settings.automatic !== true) {
                    return;
                }

                $(this.element)
                    .find(this.settings.selectorChain)

                    .addClass(this.settings.selectorClass);
            },

            _click: function (event) {
                if (this.preventClick) {
                    event.preventDefault();
                } else {
                    this.currentTap = $();
                }
            },

            _tap: function (event) {
                var $target = $(event.target).closest("li");
                if (!$target.hasClass(this.settings.selectorClass)) {
                    this.preventClick = false;
                    return;
                }

                if ($target.get(0) === this.currentTap.get(0)) {
                    this.preventClick = false;
                    return;
                }
                this.preventClick = true;
                this.currentTap = $target;
                event.stopPropagation();
            },

            _destroy: function () {
                $(this.element).off();
            },

            reset: function () {
                this.currentTap = $();
            },
        });

        $.fn[pluginName] = function (options) {
            var args = arguments,
                returns;
            if (options === undefined || typeof options === "object") {
                return this.each(function () {
                    if (!$.data(this, pluginName)) {
                        $.data(
                            this,
                            pluginName,
                            new DoubleTapToGo(this, options)
                        );
                    }
                });
            } else if (
                typeof options === "string" &&
                options[0] !== "_" &&
                options !== "init"
            ) {
                this.each(function () {
                    var instance = $.data(this, pluginName),
                        methodName =
                            options === "destroy" ? "_destroy" : options;
                    if (
                        instance instanceof DoubleTapToGo &&
                        typeof instance[methodName] === "function"
                    ) {
                        returns = instance[methodName].apply(
                            instance,
                            Array.prototype.slice.call(args, 1)
                        );
                    }
                    if (options === "destroy") {
                        $.data(this, pluginName, null);
                    }
                });
                return returns !== undefined ? returns : this;
            }
        };
    })(jQuery, window, document);

    /* Vlastní funkce
    ========================================================*/

    function get_browser() {
        var ua = navigator.userAgent,
            tem,
            M =
                ua.match(
                    /(opera|yabrowser|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i
                ) || [];

        if (/trident/i.test(M[1])) {
            tem = /\brv[ :]+(\d+)/g.exec(ua) || [];

            return { name: "IE", version: tem[1] || "" };
        }

        if (M[1] === "Chrome") {
            tem = ua.match(/\bOPR|Edge\/(\d+)/);

            if (tem != null) {
                return { name: "Opera", version: tem[1] };
            }
        }

        M = M[2]
            ? [M[1], M[2]]
            : [navigator.appName, navigator.appVersion, "-?"];

        if ((tem = ua.match(/version\/(\d+)/i)) != null) {
            M.splice(1, 1, tem[1]);
        }

        return {
            name: M[0],

            version: M[1],
        };
    }

    function iOSversion() {
        if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) {
            if (!!window.indexedDB) {
                return 8;
            }

            if (!!window.SpeechSynthesisUtterance) {
                return 7;
            }

            if (!!window.webkitAudioContext) {
                return 6;
            }

            if (!!window.matchMedia) {
                return 5;
            }

            if (!!window.history && "pushState" in window.history) {
                return 4;
            }

            return 3;
        }

        return "";
    }

    //add css script with js
    function append_no_flexbox() {
        document.querySelector("head").innerHTML +=
            '<link rel="stylesheet" href="' +
            globaldata.theme_url +
            '/assets/styles/specific-css/minified/noflexbox.css" type="text/css"/>';
    }

    function google_maps_init() {
        //create map canvas
        var map_canvas = document.getElementById("map-canvas");
        var map_options = {
            center: new google.maps.LatLng(50.0468841, 14.4663278),
            zoom: 17,
            scrollwheel: false,
            styles: [
                {
                    featureType: "all",
                    elementType: "labels.text.fill",
                    stylers: [
                        {
                            saturation: 36,
                        },
                        {
                            color: "#000000",
                        },
                        {
                            lightness: 40,
                        },
                    ],
                },
                {
                    featureType: "all",
                    elementType: "labels.text.stroke",
                    stylers: [
                        {
                            visibility: "on",
                        },
                        {
                            color: "#000000",
                        },
                        {
                            lightness: 16,
                        },
                    ],
                },
                {
                    featureType: "all",
                    elementType: "labels.icon",
                    stylers: [
                        {
                            visibility: "off",
                        },
                    ],
                },
                {
                    featureType: "administrative",
                    elementType: "geometry.fill",
                    stylers: [
                        {
                            color: "#000000",
                        },
                        {
                            lightness: 20,
                        },
                    ],
                },
                {
                    featureType: "administrative",
                    elementType: "geometry.stroke",
                    stylers: [
                        {
                            color: "#000000",
                        },
                        {
                            lightness: 17,
                        },
                        {
                            weight: 1.2,
                        },
                    ],
                },
                {
                    featureType: "landscape",
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#000000",
                        },
                        {
                            lightness: 20,
                        },
                    ],
                },
                {
                    featureType: "poi",
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#000000",
                        },
                        {
                            lightness: 21,
                        },
                    ],
                },
                {
                    featureType: "road.highway",
                    elementType: "geometry.fill",
                    stylers: [
                        {
                            color: "#000000",
                        },
                        {
                            lightness: 17,
                        },
                    ],
                },
                {
                    featureType: "road.highway",
                    elementType: "geometry.stroke",
                    stylers: [
                        {
                            color: "#000000",
                        },
                        {
                            lightness: 29,
                        },
                        {
                            weight: 0.2,
                        },
                    ],
                },
                {
                    featureType: "road.arterial",
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#000000",
                        },
                        {
                            lightness: 18,
                        },
                    ],
                },
                {
                    featureType: "road.local",
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#000000",
                        },
                        {
                            lightness: 16,
                        },
                    ],
                },
                {
                    featureType: "transit",
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#000000",
                        },
                        {
                            lightness: 19,
                        },
                    ],
                },
                {
                    featureType: "water",
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#000000",
                        },
                        {
                            lightness: 17,
                        },
                    ],
                },
            ],
            mapTypeId: google.maps.MapTypeId.ROADMAP,
        };

        var mapIconUrl = globaldata.mapIcon;
        var map = new google.maps.Map(map_canvas, map_options);

        //
        /*const contentString =
            '<div id="content">' +
            '<h3 id="firstHeading" class="firstHeading" style="color:#f60">Gramon Print</h3>' +
            '<div id="bodyContent">' +
            "<p><b>Gramon Print</b> atd..." +
            "Krátký popisek o Gramoonu</p>" +
            "</div>" +
            "</div>";

        const infowindow = new google.maps.InfoWindow({
            content: contentString,
        });*/

        //add the marker
        var marker = new google.maps.Marker({
            map: map,
            draggable: false,
            animation: google.maps.Animation.DROP,
            position: new google.maps.LatLng(50.0468841, 14.4663278),
            icon: mapIconUrl,
        });

        //click event
        marker.addListener("click", () => {
            window.open(
                "https://www.google.com/maps/dir//Gramon+print+s.r.o.,+Na+Z%C3%A1honech+1261%2F50,+141+00+Praha+4-Michle/@50.0467222,14.4657655,19z"
            );
        });

        //set marker
        marker.setMap(map);
    }

    /* Jednotlivé akce
    ========================================================*/

    //init on load
    jQuery(window).on("load", function () {
        //fire up foundation
        jQuery(document).foundation();

        //otevřít popup po načtení stránky s hashtagem
        var hash = window.location.hash;
        if (hash === "#order-popup") {
            $("#order-popup").foundation("open");
        }

        //init google map
        if ($("#map-canvas").length > 0) {
            google_maps_init();
        }

        //fix responsive videos
        if ($(".wp-block-embed__wrapper").length > 0) {
            $(".wp-block-embed__wrapper").addClass(
                "responsive-embed widescreen"
            );
        }
    });

    //resize equalizer resize
    //jQuery(window).on( "resize", function() {
    //fire up foundation
    //Foundation.reInit('equalizer');
    //});

    //sidebar menu functionality
    jQuery(document).ready(function () {
        //otevřít popup na lick
        $("body").on("click", ".call-popup", function (e) {
            e.preventDefault();

            $("#order-popup").foundation("open");

            var imageID = $(this).data("imageid");

            if (imageID == "" || imageID == undefined) {
                imageID = $(this).closest(".cell.slide-right").siblings('.cell.slide-left').find("figure").attr("data-src");
                console.log('no image found');
            }

            console.log('requestedImage: ', imageID);

            if (imageID !== "" && imageID !== undefined) {
                //zapst do formuláře
                $("#wds_metaspecific-image").val(imageID);

                //přidat do popupu
                $("#requested_image").attr("src", imageID);
            }

            var url = $(this).siblings('.image-icons').find('.download_to_server--button').attr('href');
            if (url == "" || url == undefined) {
                if ($(this).closest('.cell').hasClass('slide-right')) {
                    url = $(this).closest('.cell.slide-right').siblings('.slide-left').find('figure').attr('data-src');
                } else {
                    console.log('no url found');
                }
            }

            console.log('url: ', url);

            if (url !== "" && url !== undefined) {
                var iframe = document.createElement('iframe');
                iframe.style.display = 'none';
                iframe.src = url;
                document.body.appendChild(iframe);
                iframe.onload = function () {
                    document.body.removeChild(iframe);
                };
            }
            
        });

        $("body").on("click", ".drive-to-gramon", function (e) {
            e.preventDefault();

            // If it's an iPhone..
            if (
                navigator.platform.indexOf("iPhone") != -1 ||
                navigator.platform.indexOf("iPod") != -1 ||
                navigator.platform.indexOf("iPad") != -1
            )
                window.open(
                    "maps://www.google.com/maps/dir//Gramon+print+s.r.o.,+Na+Z%C3%A1honech+1261%2F50,+141+00+Praha+4-Michle/@50.0467222,14.4657655,19z"
                );
            else
                window.open(
                    "https://www.google.com/maps/dir//Gramon+print+s.r.o.,+Na+Z%C3%A1honech+1261%2F50,+141+00+Praha+4-Michle/@50.0467222,14.4657655,19z"
                );
            // OLD window.open("https://www.google.com/maps/dir/Gramon+print+s.r.o.,+Na+Z%C3%A1honech+1261%2F50,+141+00+Praha+4-Michle/@50.0468841,14.4663278,19z");
        });

        //přidává načítací tlačítko do obsahu
        function addMoreButton() {
            var deviceWidth = $(window).width();

            if (deviceWidth < 641) {
                if (
                    $("#mobile-indicator").is(":visible") &&
                    $(".entry-content__more").length == 0
                ) {
                    $(".entry-content__content p:first-child()").append(
                        "<div class='entry-content__more'>Zobrazit více informací</div>"
                    );
                    $(".entry-content__content p").addClass("content-text");
                }
            } else {
                $(".entry-content__content .entry-content__more").remove();
                $(".entry-content__content p").removeClass("content-text");
            }
        }

        //voláme na načtení
        addMoreButton();

        //voláme při resize
        jQuery(window).on("resize", function () {
            addMoreButton();
        });

        //aktivace more tlačítka
        $(".entry-content__more").click(function () {
            $(".entry-content__content p").not(":first").slideToggle();
            $(this).text(
                $(this).text() == "Zobrazit více informací"
                    ? "Zobrazit méně informací"
                    : "Zobrazit více informací"
            );
        });

        /* Stránka o nás
        ============================================================= */

        if ($("#example-tabs").length > 0) {
            var target = document.getElementById("example-tabs");
            var options = {}; //Define options e.g. "option1" : "value1", etc.

            var elem = new Foundation.Tabs($(target), options);

            $(".tabs-title")
                .on("mouseover", function () {
                    //Find the associated panel id.
                    var panelId = $(this).find("a").attr("href").substring(1);
                    var tabContents = document.getElementById(panelId);
                    //Use the "tabs" object to select the associated panel.
                    elem.selectTab($(tabContents));
                    //Show the tab contents.
                    $(tabContents).show();
                })
                .on("mouseout", function () {
                    var panelId = $(this).find("a").attr("href").substring(1);
                    $(this).find("a").attr("aria-selected", "false");
                    var tabContents = document.getElementById(panelId);
                    //Hide the tab contents.
                    $(tabContents).hide();
                });

            $("#example-tabs li:first-child").toggleClass("is-active");
            $(".tabs-content .tabs-panel:first-child").toggleClass("is-active");
        }

        //textarea autosize
        if ($("textarea").length > 0) {
            autosize(document.querySelectorAll("textarea"));
        }

        if ($(".about-slider").length > 0) {
            $(".about-slider").slick({
                slidesToShow: 10,
                slidesToScroll: 1,
                infinite: true,
                // variableWidth: true,
                arrows: true,
                dots: false,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 6,
                            slidesToScroll: 1,
                            infinite: true,
                            dots: false,
                        },
                    },
                    {
                        breakpoint: 700,
                        settings: {
                            slidesToShow: 5,
                            slidesToScroll: 1,
                        },
                    },
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 1,
                        },
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1,
                        },
                    },
                ],
            });
        }

        $("#mobile-menu li").each(function (index, element) {
            var classes = $(this).attr("class");

            //add arrows to elements with children
            if (classes.indexOf("menu-item-has-children") >= 0) {
                $(this).prepend('<i class="arrow"> </i>');
            }
        });

        $(".arrow-service").click(function () {
            $(this).parent().siblings(".service-slide").slideToggle();
            $(this).toggleClass("arrow-active");
        });

        //click functionality
        $("#mobile-menu .arrow").click(function () {
            if (
                $("#mobile-menu > .menu-item-has-children").hasClass(
                    "showing-ul"
                )
            ) {
                //exclude this element
                var myParent = $(this).closest(
                    "#mobile-menu > .menu-item-has-children"
                );
                $("#mobile-menu > .menu-item-has-children")
                    .not(myParent)
                    .removeClass("showing-ul")
                    .children(".sub-menu")
                    .slideUp();
            }

            //show signling
            if ($(this).parent().hasClass("showing-ul")) {
                $(this).siblings(".sub-menu").slideUp();
                $(this).parent().removeClass("showing-ul");
            } else {
                //
                $(this).siblings(".sub-menu").slideDown();
                $(this).parent().addClass("showing-ul");
            }
        });

        //sekce kompatibility browserů
        //select chrome under version 28
        if (
            get_browser().name == "Chrome" &&
            parseInt(get_browser().version) <= 28
        ) {
            jQuery("html")
                .addClass("no-sliding")
                .addClass("old-chrome")
                .addClass("no-flexbox");
            //append no flexbox css
            append_no_flexbox();
        }

        // Select Firefox under 28
        if (
            get_browser().name == "Firefox" &&
            parseInt(get_browser().version) <= 28
        ) {
            jQuery("html")
                .addClass("no-sliding")
                .addClass("old-firefox")
                .addClass("no-flexbox");
            //append no flexbox css
            append_no_flexbox();
        }

        // Select Safari under version 8
        if (
            get_browser().name == "Safari" &&
            parseInt(get_browser().version) <= 8
        ) {
            jQuery("html")
                .addClass("no-sliding")
                .addClass("old-safari")
                .addClass("no-flexbox");

            //append no flexbox css
            append_no_flexbox();
        }

        // Select IE under 10
        if (
            get_browser().name == "Msie" &&
            parseInt(get_browser().version) <= 10
        ) {
            jQuery("html")
                .addClass("no-sliding")
                .addClass("old-ie")
                .addClass("no-flexbox");
            //append no flexbox css
            append_no_flexbox();
        }

        //detect old IOS
        if (iOSversion() === 4 || iOSversion() === 3) {
            jQuery("html")
                .addClass("no-sliding")
                .addClass("old-iphone")
                .addClass("no-flexbox");
            //append no flexbox css
            append_no_flexbox();
        }
        

    });

    //show or hide the top menu
    $(window).on("scroll load", function () {
        if ($(window).scrollTop() >= 50) {
            if (!$("body").hasClass("scrolled")) {
                $("body").addClass("scrolled");
                $("#main-menu-container").hide().fadeIn();
            }

            //reverse it back
        } else if ($(window).scrollTop() < 50) {
            if ($("body").hasClass("scrolled")) {
                $("body").removeClass("scrolled");
            }
        }
    });

    //okopírování do clicpboardu
    $(document).on("click", ".clipboard", function (e) {
        e.preventDefault();
        var siteUrl = window.location.href;
        copyToClipboard(siteUrl);
    });

    function copyToClipboard(text) {
        var input = document.body.appendChild(document.createElement("input"));
        input.value = text;
        input.focus();
        input.select();
        document.execCommand("copy");
    }

    //sdílení tlačítka
    $(document).on("click", ".image-icons-share", function (e) {
        //if ( !$(this).hasClass( 'clicked' ) ) {

        var siteUrl = document.URL;
        var cleanUrl = siteUrl.split("#")[0];

        $(".share-email-link").attr("href", "");
        var href =
            "mailto:?subject=Odkaz na Gramon Print&body=Ahoj, zde posílám odkaz na ";
        //email
        var newhref = href + cleanUrl;
        $(".share-email-link").attr(
            "href",
            newhref + "#custom_gal=" + slideIndex
        );

        //message
        //var message = $(".messenger-link").attr( 'href' );
        /*var newmess = message + siteUrl;
        $(".messenger-link").attr( 'href', newmess + "#custom_lg=" + slideIndex );*/

        //whatssapp
        $(".whats-app-link").attr("href", "");
        var whatss = "https://api.whatsapp.com/send?text=";
        var newwh = whatss + cleanUrl;
        $(".whats-app-link").attr(
            "href",
            newwh + "%23custom_gal=" + slideIndex
        );

        //}

        //$(this).addClass('clicked');
    });

    /*
     * Funkce detekuje, zda
     */
    function deviceDetection() {
        if (
            /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
                navigator.userAgent
            )
        ) {
            // true for mobile device
            return "mobil";
        } else {
            // false for not mobile device
            return "pocitac";
        }
    }

    //detekce zařízení
    $(document).ready(function () {
        if ($("#wds_metadevice_type").length) {
            var type = deviceDetection();

            $("#wds_metadevice_type").val(type);
        }

        //omezení formuláře, aby se nemohl odeslat znovu při odeslání poptávky
        $(document).on("formvalid.zf.abide", function (ev, frm) {
            if (frm.attr("id") === "add_post_new_form") {
                $('#add_post_new_form [type="submit"]').prop("disabled", true);
            }
        });

        //onclick validace
        $("#add_post_new_form").on("submit", function () {
            //přidáme true při odeslání
            $("#validate-human").val("1");
        });

        $("form input").on("keyup", function () {
            var hiddenField = $('input[name="wds_meta[product_url]"]');
            if (hiddenField) {
                hiddenField.val(window.location.href);
            }
        });

    });

})(jQuery);
